{
  "colorSwatchPicker": "דוגמיות צבע",
  "dropzoneLabel": "DropZone",
  "selectPlaceholder": "בחר פריט",
  "tableResizer": "שינוי גודל"
}
